import { useEffect, useState } from 'react';

import {
  classifyDeviceUx,
  getDeviceUxSnapshot,
  type DeviceUxProfile,
} from './deviceUx';

const WATCHED_MEDIA_QUERIES = [
  '(pointer: fine)',
  '(any-pointer: fine)',
  '(hover: hover)',
  '(any-hover: hover)',
  '(prefers-reduced-motion: reduce)',
];

const readProfile = (): DeviceUxProfile => classifyDeviceUx(getDeviceUxSnapshot());

export function useDeviceUxProfile(): DeviceUxProfile {
  const [profile, setProfile] = useState<DeviceUxProfile>(() => readProfile());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    let frameId = 0;
    const update = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(() => {
        setProfile(readProfile());
      });
    };

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    const mediaQueries = WATCHED_MEDIA_QUERIES
      .map((query) => window.matchMedia?.(query))
      .filter((query): query is MediaQueryList => Boolean(query));

    mediaQueries.forEach((query) => {
      query.addEventListener?.('change', update);
      query.addListener?.(update);
    });

    update();

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      mediaQueries.forEach((query) => {
        query.removeEventListener?.('change', update);
        query.removeListener?.(update);
      });
    };
  }, []);

  return profile;
}
